import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBoxComponent } from './search-box.component';
import { CopilotSearchInputComponent } from './components/copilot-search-input/copilot-search-input.component';
import { IsFeatureFlagEnabledPipeModule } from '../../pipes';
import { ChipsInputFormFieldModule } from '../../components';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    IsFeatureFlagEnabledPipeModule,
    ChipsInputFormFieldModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    FaIconComponent,
  ],
  declarations: [SearchBoxComponent, CopilotSearchInputComponent],
  exports: [SearchBoxComponent],
})
export class SearchBoxModule { }
